import React from "react";
import { useTranslation } from "react-i18next";
import {
  useDisableProjectResource,
  useResourceRetrieval,
} from "@planzone/view-models";
import { ProjectResource } from "@planzone/dto";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import { InfoResource } from "./infoResource";
import styles from "./styles.scss";
import { Safeguard } from "@scenes/safeguard";
import { UseCases } from "@planzone/core";
import { WorkspaceContext } from "@scenes/workspaceContext";

function ProjectResourceDeactivation({ projectResource, cancel }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending: isResourceRetrievalPending,
    isRequestSuccess,
    isRequestFailure,
    resource,
    retrieveResource,
  } = useResourceRetrieval(projectResource.resource.uuid);
  const { isRequestPending, disableProjectResource } =
    useDisableProjectResource(projectResource);
  const [formData, setFormData] =
    React.useState<ProjectResource>(projectResource);

  React.useEffect(() => {
    !isResourceRetrievalPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveResource(projectResource.resource.uuid);
  }, [projectResource.resource.uuid]);

  React.useEffect(() => {
    setFormData(projectResource);
  }, [projectResource]);

  return (
    <WorkspaceContext type="project" project={projectResource.project}>
      <Modal header={t("disableProjectResource.title")} close={cancel}>
        <Safeguard useCases={[UseCases.disableProjectResource]}>
          {({ canDisableProjectResource }) => (
            <div className={styles.projectResourceDeactivation}>
              <div className={styles.body}>
                <div className={styles.group}>
                  <p className={styles.warning}>
                    {t("disableProjectResource.warning")}
                  </p>
                </div>
                <InfoResource
                  resource={
                    isRequestSuccess ? resource : projectResource.resource
                  }
                />
              </div>
              {canDisableProjectResource && (
                <div className={styles.footer}>
                  <Button type="cancel" press={cancel}>
                    {t("disableProjectResource.cancel")}
                  </Button>
                  <Button
                    type={"submit"}
                    status={isRequestPending ? "pending" : "none"}
                    isDisabled={isRequestPending}
                    press={() =>
                      disableProjectResource({
                        projectResource,
                        nextProjectResource: formData,
                      })
                    }
                  >
                    {t("disableProjectResource.save")}
                  </Button>
                </div>
              )}
            </div>
          )}
        </Safeguard>
      </Modal>
    </WorkspaceContext>
  );
}

export { ProjectResourceDeactivation };
